import React, { useState } from 'react';
import '../../style/keyEn.css';
const keyEn1 = require('../../assets/zdqyfb.png');
const keyEn2 = require('../../assets/zdqyfb.png');

function KeyEn() {
    // 企业数据
    const data = [
        {
            name: 'xlc',
            pic: keyEn1,
            coords: '',
            company: [
                {
                    name: '华能（三亚）清洁能源有限公司',
                    qyxz: '有限责任公司',
                    zczj: '2000万人民币',
                    dz: '三亚市育才生态区育才大道育才中学旁',
                    sshy: '新能源产业'
                },
                {
                    name: '海南能聚绿色能源科技有限公司',
                    qyxz: '有限责任公司',
                    zczj: '5000万人民币',
                    dz: '三亚市育才生态区育才大道35号',
                    sshy: '新能源产业'
                },
                {
                    name: '三亚优旅农业有限公司',
                    qyxz: '有限责任公司',
                    zczj: '1000万人民币',
                    dz: '三亚市育才生态区育才大道金才橡胶加工厂内１号楼',
                    sshy: '从事农业'
                },
                {
                    name: '三亚市育才生态投资发展有限公司',
                    qyxz: '有限责任公司',
                    zczj: '1000万人民币',
                    dz: '三亚市育才生态区育才大道１号',
                    sshy: '从事公共设施管理业'
                },
                {
                    name: '三亚万橡雨林那会农业产业园有限公司',
                    qyxz: '有限责任公司',
                    zczj: '2000万人民币',
                    dz: '三亚市育才生态区立才农场五队３栋103房',
                    sshy: '从事农、林、牧、渔专业'
                },
                {
                    name: '三亚育才生态旅业发展有限公司',
                    qyxz: '有限责任公司',
                    zczj: '6371人民币',
                    dz: '三亚市育才生态区育才大道育才现代农业产业园内',
                    sshy: '从事商务服务业'
                }
            ]
        },
        {
            name: 'sjc',
            pic: keyEn2,
            coords: '',
            company: [
                {
                    name: '三亚上品华庭地产有限公司3333333333',
                    qyxz: '有限责任公司（自然人投资或控股）',
                    zczj: '5000万元人民币',
                    dz: '海南省三亚市吉阳区新月路8号华庭国际商务中心18楼',
                    sshy: '房地产业'
                }
            ]
        }
    ]
    // 是否进入详情版面
    const [intoDetail, setIntoDetail] = useState(false);
    // 地图选中区域
    const [cCountry, setCCounty] = useState('xlc');
    // 选中公司
    const [cCompany, setCCompany] = useState({})
    // 过滤数据方法
    const filterData = (data, con) => {
        const d = data.filter(item => item.name === con);
        return d[0].company;
    }
    return (
        <div className="keyEn">
            <div className="keyEn-pic">
                {
                    data.map((item, i) => (
                        <img
                            key={i}
                            className={`keyEn-pic__img ${item.name === cCountry ? 'active' : ''}`}
                            src={item.pic}
                            alt="Planets"
                            useMap="#planetmap"
                        />
                    ))
                }
                <map name="planetmap" id="regionMap">
                    {
                        data.map((item, i) => (
                            <area
                                key={i}
                                name={item.name}
                                shape="poly"
                                coords={item.coords}
                                style={{ cursor: 'pointer' }}
                                alt={item.name}
                                onClick={(e) => {
                                    // setCCounty(e.target.getAttribute('name'))
                                }}
                                onMouseMove={(e) => {
                                    // if (e.target.getAttribute('name') !== cCountry) {
                                    //     setCCounty(e.target.getAttribute('name'))
                                    // }
                                }}
                            />
                        ))
                    }
                </map>
            </div>
            <div className="keyEn-table">
                <div className="keyEn-table__name">重点纳税企业名单</div>
                {
                    !intoDetail
                    &&
                    <div className="keyEn-table__main">
                        <p className="keyEn-table__main--title">
                            <span className="title-num">编号</span>
                            <span className="title-name">企业名称</span>
                        </p>
                        {
                            filterData(data, cCountry).map((item, i) => (
                                < p
                                    key={i}
                                    className="keyEn-table__main--row"
                                    onClick={() => {
                                        setIntoDetail(true)
                                        setCCompany({ ...item })
                                    }}
                                >
                                    <span className="row-num">{i + 1}</span>
                                    <span className="row-name">{item.name}</span>
                                </p>
                            ))
                        }
                    </div>
                }
                {
                    intoDetail
                    &&
                    <div className="keyEn-table__detail">
                        <p className="keyEn-table__detail--row">
                            <span className="name">{cCompany.name}</span>
                            <span
                                className="iconfont icon-guanbi"
                                onClick={() => {
                                    setIntoDetail(false)
                                }}
                            ></span>
                        </p>
                        <p className="keyEn-table__detail--row"><span className="info">企业性质：</span><span className="val">{cCompany.qyxz}</span></p>
                        <p className="keyEn-table__detail--row"><span className="info">注册资金：</span><span className="val">{cCompany.zczj}</span></p>
                        <p className="keyEn-table__detail--row"><span className="info">地址：</span><span className="val">{cCompany.dz}</span></p>
                        <p className="keyEn-table__detail--row"><span className="info">所属行业：</span><span className="val">{cCompany.sshy}</span></p>
                    </div>
                }
            </div>
        </div >
    );
}

export default KeyEn;
